import { render, staticRenderFns } from "./intellectualProperty.vue?vue&type=template&id=f119d64e&scoped=true&"
import script from "./intellectualProperty.vue?vue&type=script&lang=js&"
export * from "./intellectualProperty.vue?vue&type=script&lang=js&"
import style0 from "./intellectualProperty.vue?vue&type=style&index=0&id=f119d64e&prod&scoped=true&lang=css&"
import style1 from "./intellectualProperty.vue?vue&type=style&index=1&id=f119d64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f119d64e",
  null
  
)

export default component.exports